import { useQuery } from 'react-query';

import { getDashboardList as queryFn } from 'api/endPoints/getDashboardList';

import { IGetDashboard } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useQueryGetDashboards = () => {
    return useQuery<IGetDashboard, QueryError>(['getDashboard'], () => queryFn());
};
